import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Router } from '@angular/router';
import { accountMenuMock } from '../../mock/account-menu-mock';

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: [
        //   '../../../../../../src/assets/css/ds-core.css',
        //   '../../../../../../src/assets/css/ds-button.css',
        //   '../../../../../../src/assets/css/ds-card.css',
        //   '../../../../../../src/assets/css/ds-form.css',
        //   '../../../../../../src/assets/css/ds-modal.css',
        //   '../../../../../../src/assets/css/ds-step-indicator.css',
        //   '../../../../../../src/assets/css/ds-tabs.css',
        //   '../../../../../../src/assets/css/ds-tile.css',
        './account.component.scss',
        //
        './role-request/role-request-home/role-request-home.component.css'
    ],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AccountComponent implements OnInit {
  private router = inject(Router);


  menudata = accountMenuMock;
  selectedmenuitem = this.menudata?.length > 0 ? this.menudata[0]?.label: '';
  routeFlag = false;

  ngOnInit(): void {
    this.routeFlag = false;
  }

  public onTileClick = (e) => {
  }

  navigateUrl() {
    this.routeFlag = true;
    this.router.navigateByUrl('user-profile/account/account-details/organizations-roles');
  }
  navigatContactVerification() {
    this.routeFlag = true;
    this.router.navigateByUrl('user-profile/account/account-details/contact-verification');
  }

  navigatRoleRequest() {
    this.routeFlag = true;
    this.router.navigateByUrl('user-profile/account/account-details/role-request');
  }
  
}
